// deno-fmt-ignore-file
import { Number } from '../../types/number.mjs';
import { String } from '../../types/string.mjs';
import { Symbol } from '../../types/symbol.mjs';
import { Union } from '../../types/union.mjs';
export function FromAny() {
    return Union([Number(), String(), Symbol()]);
}
